module.exports = __webpack_public_path__ + "static/media/quad3.50e422b1.png";